var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-zoom',
                        view: publicPath + 'sprite.svg#view-icon-zoom',
                        viewBox: '0 0 55 55',
                        title: 'icons/fonctions/zoom',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };